import { ReactNode } from "react";
import "./SignupUI.scss";

interface SignupSubmitProps {
  id?: string;
  children: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  /** Receives the click event: several steps' handlers call `preventDefault`. */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit";
  variant?: "primary" | "ghost";
  dataCy?: string;
}

/** Primary step action. Shows a spinner in place of the label while working. */
export const SignupSubmit = ({
  id,
  children,
  disabled,
  loading,
  onClick,
  type = "button",
  variant = "primary",
  dataCy,
}: SignupSubmitProps) => (
  <button
    type={type}
    id={id}
    data-cy={dataCy}
    className={`suBtn suBtn--${variant}`}
    disabled={disabled || loading}
    onClick={onClick}
  >
    {loading ? <span className="suBtn__spinner" aria-label="Loading" /> : children}
  </button>
);

/**
 * Invisible submit control.
 *
 * The visible step button lives in `SignupStep`'s actions slot, outside the
 * `<form>`, so it can't be the form's submit button. Browsers only submit on
 * Enter implicitly when a form has one text input *or* a submit button — this
 * supplies the latter, restoring keyboard submission on multi-field steps.
 * Hidden from the tab order and from assistive tech; the real button is the
 * one users interact with.
 */
export const SignupEnterSubmit = (): JSX.Element => (
  <button type="submit" className="suEnterSubmit" tabIndex={-1} aria-hidden="true" />
);
